import {APIChannelService} from "../../config/axios-channel-service";

const api = new APIChannelService();

export const RegisterChannel = {
  filter(payload) {
    return api.postFilter(
      `/services/cms/api/cms-world-bank/v1.0/req-mapping-world-bank/all`,
      payload
    );
  },
  approve({ id, otpValue }) {
    const url = `/api/v1/channel/register/${id}/approve`;

    if (!!otpValue && otpValue.length === 6) {
      return api.put(url, { otp: otpValue, step: 1 });
    }

    return api.put(`/api/v1/channel/register/${id}/approve`);
  },
  reject({ id, reason: content }) {
    return api.put(`/api/v1/channel/register/${id}/reject`, {
      content,
    });
  },
  create(payload) {
    const { channelTempId } = payload;
    const url = `/api/v1/channel/register`;
    return api.post(
      !!channelTempId ? `${url}?channelTempId=${channelTempId}` : url,
      payload
    );
  },
  paperType() {
    return api.get("/api/v1/paper-type/channel");
  },
  channelTypeByRole() {
    // const roleId = 0;
    return api.get(`/api/v1/channel-type/user`);
  },
  channelTypeByUser() {
    // const roleId = 0;
    return api.get(`/api/v1/channel-tier/user`);
  },
};
